import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadBankAccountTypes,
  loadBankAccountTypesFailure,
  loadBankAccountTypesSuccess,
} from './bank-account-types.actions';

@Injectable()
export class BankAccountTypesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);

  constructor() {}

  loadBankAccountTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBankAccountTypes),
      switchMap(() =>
        this.referenceService.referenceLookupGetBankAccountTypesGet().pipe(
          map((response) => loadBankAccountTypesSuccess({ bankAccountTypes: response.result || [] })),
          catchError((error) => of(loadBankAccountTypesFailure({ error }))),
        ),
      ),
    ),
  );
}
